import { FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import { getIsActive } from '@/utils'
import styles from './index.module.scss'

type Props = {
  forExperts?: boolean
}

export const JobsNavbar: FC<Props> = observer(({ forExperts = false }) => {
  const router = useRouter()
  const projectItems = [
    {
      label: 'Projects',
      href: `/jobs`,
      isActive: getIsActive(['/jobs'], router, true, true),
      isTBD: false,
    },
    {
      label: 'Saved Projects',
      href: `/jobs/saved`,
      isActive: getIsActive(['/jobs/saved'], router, true, true),
      isTBD: false,
    },
  ]

  const expertItems = [
    {
      label: 'Experts',
      href: '/experts',
      isActive: getIsActive(['/experts'], router, true, true),
      isTBD: false,
    },
  ]

  const items = forExperts ? expertItems : projectItems

  return (
    <div className={styles.container}>
      {items.map((item) => (
        <div key={item.label} className={styles.menuItem}>
          <Link href={item.href}>
            <a
              className={classNames(styles.link, {
                [styles.isActive]: item.isActive,
              })}
            >
              {item.label}
              {item.isTBD && <span className={styles.badge}>Comming soon</span>}
            </a>
          </Link>
        </div>
      ))}
    </div>
  )
})
